import { useMemo } from 'react'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { getHeyImmoExperimentState } from '../../../utils/features/heyImmoExperiment'

export function useHeyImmoExperimentTracking(isHeyImmoSupported: boolean) {
  const { value: heyImmoFeatureValue, isLoadedFromBackend: isHeyImmoFeatureLoadedFromBackend } = useFeatureSwitch(
    FeatureSwitch.PPA_12148_HEYIMMO
  )

  return useMemo(
    () =>
      getHeyImmoExperimentState({
        isHeyImmoSupported,
        isHeyImmoFeatureLoadedFromBackend,
        heyImmoFeatureValue,
      }).trackingParameters,
    [heyImmoFeatureValue, isHeyImmoFeatureLoadedFromBackend, isHeyImmoSupported]
  )
}
